<!-- 折线图 -->
<template>
  <div class="chart-container">
    <div ref="chart" :style="{ width: width, height: height }"></div>
  </div>
</template>

<script>
/* eslint-disable no-undef, vue/no-mutating-props */
import * as echarts from 'echarts';

export default {
  name: 'EchartsLineChart',
  
  props: {
    title: {
      type: String,
      default: '设备使用统计'
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    unit: {
      type: String,
      default: '台'
    },
    timeData: {
      type: Array,
      default: () => ['06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00']
    },
    chartData: {
      type: Array,
      default: () => [
        {
          name: '设备1',
          data: [5, 8, 12, 15, 18, 16, 14, 12, 10],
          color: '#5470c6'
        },
        {
          name: '设备2',
          data: [3, 6, 9, 11, 13, 15, 14, 12, 10],
          color: '#91cc75'
        },
        {
          name: '设备3',
          data: [2, 4, 7, 10, 12, 14, 16, 15, 13],
          color: '#fac858'
        },
        {
          name: '设备4',
          data: [1, 3, 5, 8, 10, 12, 11, 9, 7],
          color: '#ee6666'
        },
        {
          name: '设备5',
          data: [4, 7, 10, 13, 16, 18, 17, 15, 12],
          color: '#73c0de'
        },
        {
          name: '设备6',
          data: [6, 9, 12, 15, 18, 16, 14, 12, 10],
          color: '#3ba272'
        },
        {
          name: '设备7',
          data: [8, 11, 14, 17, 19, 18, 16, 13, 10],
          color: '#fc8452'
        },
        {
          name: '设备8',
          data: [10, 13, 16, 19, 21, 20, 18, 15, 12],
          color: '#9a60b4'
        },
        {
          name: '设备9',
          data: [12, 15, 18, 21, 23, 22, 20, 17, 14],
          color: '#ea7ccc'
        },
        {
          name: '设备10',
          data: [14, 17, 20, 23, 25, 24, 22, 19, 16],
          color: '#7ebf42'
        },
        {
          name: '设备11',
          data: [16, 19, 22, 25, 27, 26, 24, 21, 18],
          color: '#e6d450'
        },
        {
          name: '设备12',
          data: [18, 21, 24, 27, 29, 28, 26, 23, 20],
          color: '#f2a7c3'
        },
      ]
    },
    yMax: {
      type: Number,
      default: 25
    },
    yInterval: {
      type: Number,
      default: 5
    },
    smooth: {
      type: Boolean,
      default: true
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    // 新增下载相关属性
    downloadFileName: {
      type: String,
      default: 'line_chart'
    },
    downloadType: {
      type: String,
      default: 'png',
      validator: (value) => ['png', 'jpeg'].includes(value)
    },
    // 新增：是否显示工具箱
    showToolbox: {
      type: Boolean,
      default: true
    },
    // 新增：下载时使用的背景色
    downloadBackgroundColor: {
      type: String,
      default: '#ffffff'
    },
    // 新增：颜色序列配置
    colors: {
      type: Array,
      default: () => [
        '#5470c6', '#91cc75', '#fac858', '#ee6666', 
        '#73c0de', '#3ba272', '#fc8452', '#9a60b4',
        '#ea7ccc', '#7ebf42', '#e6d450', '#f2a7c3',
        '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80'
      ]
    },
    // 新增：图表边距配置
    chartMargin: {
      type: [String, Number],
      default: '5%'
    },
    // 新增：图表顶部边距
    chartTopMargin: {
      type: [String, Number],
      default: 'auto'
    },
    // 新增：图表底部边距
    chartBottomMargin: {
      type: [String, Number],
      default: 'auto'
    },
    // 新增：图表左侧边距
    chartLeftMargin: {
      type: [String, Number],
      default: 'auto'
    },
    // 新增：图表右侧边距
    chartRightMargin: {
      type: [String, Number],
      default: 'auto'
    },
    // 新增：图例位置
    legendPosition: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
    }
  },
  
  data() {
    return {
      chartInstance: null
    }
  },
  
  methods: {
    // 下载图片
    downloadImage() {
      if (!this.chartInstance) {
        console.warn('图表实例未初始化');
        return false;
      }

      try {
        // 获取图表图片的 Data URL
        const dataURL = this.chartInstance.getDataURL({
          type: this.downloadType,
          pixelRatio: 2,
          backgroundColor: this.downloadBackgroundColor,
          excludeComponents: ['toolbox']
        });

        // 创建下载链接
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${this.downloadFileName}_${new Date().getTime()}.${this.downloadType}`;
        
        // 触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        console.log('折线图下载成功');
        return true;
      } catch (error) {
        console.error('折线图下载失败:', error);
        alert('下载失败，请重试');
        return false;
      }
    },

    // 获取工具箱配置
    getToolboxConfig() {
      if (!this.showToolbox) {
        return undefined;
      }
      
      return {
        feature: {
          saveAsImage: {
            title: '保存为图片',
            type: this.downloadType,
            name: this.downloadFileName,
            pixelRatio: 2,
            backgroundColor: this.downloadBackgroundColor,
            excludeComponents: ['toolbox'],
          }
        },
        right: 10,
        top: 10,
        iconStyle: {
          borderColor: '#666'
        }
      };
    },

    // 获取图例配置
    getLegendConfig() {
      if (!this.showLegend) {
        return undefined;
      }
      
      const legendData = this.chartData.map(item => item.name);
      
      // 根据图例位置配置
      switch (this.legendPosition) {
        case 'top':
          return {
            data: legendData,
            top: '3%',
            left: 'center',
            orient: 'horizontal',
            padding: [5, 5, 5, 5],
            itemGap: 15,
            textStyle: {
              fontSize: 12
            }
          };
        case 'bottom':
          return {
            data: legendData,
            bottom: '3%',
            left: 'center',
            orient: 'horizontal',
            padding: [5, 5, 5, 5],
            itemGap: 15,
            textStyle: {
              fontSize: 12
            }
          };
        case 'left':
          return {
            data: legendData,
            left: '3%',
            top: 'center',
            orient: 'vertical',
            padding: [5, 5, 5, 5],
            itemGap: 15,
            textStyle: {
              fontSize: 12
            }
          };
        case 'right':
          return {
            data: legendData,
            right: '3%',
            top: 'center',
            orient: 'vertical',
            padding: [5, 5, 5, 5],
            itemGap: 15,
            textStyle: {
              fontSize: 12
            }
          };
        default:
          return {
            data: legendData,
            top: '3%',
            left: 'center',
            orient: 'horizontal',
            padding: [5, 5, 5, 5],
            itemGap: 15,
            textStyle: {
              fontSize: 12
            }
          };
      }
    },

    // 获取网格配置（居中显示）
    getGridConfig() {
      // 基础配置
      let left = this.chartLeftMargin !== 'auto' ? this.chartLeftMargin : this.chartMargin;
      let right = this.chartRightMargin !== 'auto' ? this.chartRightMargin : this.chartMargin;
      let top = this.chartTopMargin !== 'auto' ? this.chartTopMargin : '10%';
      let bottom = this.chartBottomMargin !== 'auto' ? this.chartBottomMargin : '10%';
      
      const hasLegend = this.showLegend && this.chartData && this.chartData.length > 0;
      
      // 根据图例位置自动调整
      if (hasLegend && this.chartTopMargin === 'auto' && this.chartBottomMargin === 'auto') {
        switch (this.legendPosition) {
          case 'top':
            top = '25%';  // 为顶部图例留出空间
            bottom = '8%';
            break;
          case 'bottom':
            top = '8%';
            bottom = '15%';  // 为底部图例留出空间
            break;
          case 'left':
            left = '15%';  // 为左侧图例留出空间
            right = '8%';
            top = '8%';
            bottom = '8%';
            break;
          case 'right':
            left = '8%';
            right = '15%';  // 为右侧图例留出空间
            top = '8%';
            bottom = '8%';
            break;
        }
      }
      
      // 如果没有图例，进一步优化居中效果
      if (!hasLegend && this.chartTopMargin === 'auto' && this.chartBottomMargin === 'auto') {
        top = '10%';
        bottom = '10%';
      }
      
      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        containLabel: true
      };
    },

    // 初始化图表配置
    getChartOption() {
      const series = this.chartData.map(item => ({
        name: item.name,
        type: 'line',
        smooth: this.smooth,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          width: 3,
          color: item.color
        },
        itemStyle: {
          color: item.color
        },
        data: item.data
      }));

      return {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let result = params[0].name + '<br/>';
            params.forEach(item => {
              result += `${item.marker} ${item.seriesName}: ${item.value} ${this.unit}<br/>`;
            });
            return result;
          }
        },
        legend: this.getLegendConfig(),
        grid: this.getGridConfig(),
        toolbox: this.getToolboxConfig(),
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.timeData,
          axisLine: {
            lineStyle: {
              color: '#e0e0e0'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 11
          }
        },
        yAxis: {
          type: 'value',
          max: this.yMax,
          min: 0,
          interval: this.yInterval,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#e0e0e0'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 11,
            formatter: `{value}`
          },
          name: this.unit,
          nameTextStyle: {
            color: '#666',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5',
              type: 'dashed'
            }
          }
        },
        series
      };
    },

    initChart() {
      if (!this.$refs.chart) return;

      const option = this.getChartOption();

      if (!this.chartInstance) {
        this.chartInstance = echarts.init(this.$refs.chart);
      }
      
      this.chartInstance.setOption(option);
    },

    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },

    // 获取图表实例
    getInstance() {
      return this.chartInstance;
    },
    
    // 提供给父组件调用的方法：重置图表大小
    resize() {
      this.handleResize();
    }
  },
  
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    window.removeEventListener('resize', this.handleResize);
  },
  
  watch: {
    chartData: {
      handler() {
        this.initChart();
      },
      deep: true
    },
    timeData: {
      handler() {
        this.initChart();
      }
    },
    yMax() {
      this.initChart();
    },
    yInterval() {
      this.initChart();
    },
    smooth() {
      this.initChart();
    },
    showLegend: {
      handler() {
        this.initChart();
      }
    },
    unit() {
      this.initChart();
    },
    showToolbox() {
      this.initChart();
    },
    // 新增属性的监听
    legendPosition: {
      handler() {
        this.initChart();
      }
    },
    chartMargin: {
      handler() {
        this.initChart();
      }
    },
    chartTopMargin: {
      handler() {
        this.initChart();
      }
    },
    chartBottomMargin: {
      handler() {
        this.initChart();
      }
    },
    chartLeftMargin: {
      handler() {
        this.initChart();
      }
    },
    chartRightMargin: {
      handler() {
        this.initChart();
      }
    }
  },
  
  // 暴露方法给父组件
  expose: ['downloadImage', 'handleResize', 'initChart', 'getInstance', 'resize']
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>